import React from "react";
import { ContentSection, GridRow, GridColumn, LabeledText, CodedProperty, ButtonRenderProps } from "sprint-common-web";

import { getLanguageDisplayName } from "../../../../../../../common/types/Language";
import {
    EditCloudVideoAssetSubtitleAside,
    EditCloudVideoAssetSubtitleAsideProps
} from "./edit/EditCloudVideoSubtitleButtonAside";

interface CloudSubtitleLanguageSectionProps {
    isLoading: boolean;
    language: CodedProperty;
}

export const CloudSubtitleLanguagesSection: React.FunctionComponent<CloudSubtitleLanguageSectionProps> = (
    props: CloudSubtitleLanguageSectionProps
) => {
    const { isLoading, language } = props;

    const editSubtitleButton: ButtonRenderProps<EditCloudVideoAssetSubtitleAsideProps> = {
        isLabeled: true,
        render: EditCloudVideoAssetSubtitleAside,
        subtitleId: language.id
    };

    return (
        <ContentSection header="Languages" isLoading={isLoading} buttons={[editSubtitleButton]}>
            <GridRow style={{ height: 200 }}>
                <GridColumn sm={12}>
                    <LabeledText label="Subtitles" value={getLanguageDisplayName(language)} />
                </GridColumn>
            </GridRow>
        </ContentSection>
    );
};
